import { useSettings } from '@wu/widget-core';
import { isStandalone, meta } from '../../../constants';
import type { ChatsChannelBase } from '../../../constants/types';
import { ChatsChannelType, ChatsProvider } from '../../../constants/types';

export const useChannelSettings = () => {
  const {
    page,
    accountId,
    phone,
    link,
    facebookPage,
    callNumber,
    customButtonLink,
    discordAccountId,
    email,
    getDirections,
    googleMaps,
    instagramAccountId,
    kakaoTalkId,
    lineAccountId,
    rumbletalkChatId,
    sms,
    snapchatUsername,
    telegramLink,
    twitterUsername,
    viberPhone,
    weChatAccountId,
    whatsappPhone,
    saveContactFullName,
    saveContactPhoneNumber,
    channels: channelsFromSettings
  } = useSettings();

  const standaloneChannel = {
    [ChatsProvider.whatsapp]: {
      type: ChatsChannelType.whatsapp,
      whatsappPhone: phone
    },
    [ChatsProvider.facebook]: {
      type: ChatsChannelType.facebook,
      facebookPage: page
    },
    [ChatsProvider.instagram]: {
      type: ChatsChannelType.instagram,
      instagramAccountId: accountId
    },
    [ChatsProvider.telegram]: {
      type: ChatsChannelType.telegram,
      telegramLink: link
    },
    [ChatsProvider.viber]: {
      type: ChatsChannelType.viber,
      viberPhone: phone
    },
    [ChatsProvider.line]: {
      type: ChatsChannelType.line,
      lineAccountId: accountId
    },
    [ChatsProvider.discord]: {
      type: ChatsChannelType.discord,
      discordAccountId: accountId
    },
    [ChatsProvider.all]: {}
  }[meta.provider];

  const defaultChannels = {
    whatsappPhone,
    facebookPage,
    instagramAccountId,
    telegramLink,
    viberPhone,
    lineAccountId,
    discordAccountId,
    callNumber,
    customButtonLink,
    email,
    getDirections,
    googleMaps,
    kakaoTalkId,
    rumbletalkChatId,
    sms,
    snapchatUsername,
    twitterUsername,
    weChatAccountId,
    saveContactFullName,
    saveContactPhoneNumber
  };

  const channels = isStandalone
    ? [standaloneChannel as ChatsChannelBase]
    : channelsFromSettings;

  return { channels, defaultChannels };
};
